import '../../sass/pages/_chapter100Years.scss';
import gsap from "gsap";
// @ts-ignore
import * as Parallax from "parallax-js";
import Modal from "../components/modal";
import { apiService } from "../services/api";
const api = new apiService();

import { ScrollTriggerAll } from "../components/scrollTrigger";
import { setStickHandler, animateButterfly } from "../utils/helpers";
import { dama } from "../../../modules/dama";
const dm = new dama();

declare global {
  interface Window {
    drupalSettings: any;
    openPopUpTapit(): any;
    scrollInfo: any;
    dataLayer: any;
  }
}

const btnGoTrivia: HTMLLinkElement = document.querySelector('#btnGoTrivia');
btnGoTrivia && localStorage.setItem('seeChapter100Years', btnGoTrivia.href)

window.addEventListener('load', () => {
  chapter100Years()
})

export const chapter100Years = async () => {
  loadModals();
  loadAnimation();
  hideFizBlock();
  window.addEventListener('scroll', (event) => {
    const stickyMobile = document.querySelector('.ca-sticky__desc')
    if (window.scrollY >= 1100) {
      stickyMobile && stickyMobile.classList.remove('hideSticky')
    }
    else {
      stickyMobile && stickyMobile.classList.add('hideSticky')
    }
  });
};

// OCULTA EL BLOQUE FIZBLOCK
function hideFizBlock() {
  window.onload = () => {
    let refElm = document.querySelector("#block-fizbtnsound");
    refElm && refElm.remove();
  };
}

// CARGA LAS ANIMACIONES DE LOS ELEMENTOS
function loadAnimation() {
  setTitleAnimation();
  setTopFlowersAnimation();
  setTopContainAnimation();
  setTimeout(() => setStickHandler(), 2000);
  setHandlerShareButton();
  loadChapterButterfly();
  loadParallax();
  dataLayer();
  window.addEventListener('load', () => showSticky())
}

async function loadModals() {
  const userTapit: any = await api.getUSerTapit()
  let shareContents = document.querySelectorAll('#shareModal [data-share]')

  new Modal('#shareModal', {
    activator: '#shareModalButton, #videoShareBtn, #registerShareBtn',
    onOpen: () => {
      let activeSection;
      if (!userTapit.message) activeSection = Array.from(shareContents).find(content => content.getAttribute('data-share') == 'logged')
      else activeSection = Array.from(shareContents).find(content => content.getAttribute('data-share') == 'nologged')
      activeSection.classList.remove('ca-share-modal--hide')
    }
  })

  new Modal('#pointsModal')
  new Modal('#videoModal', {
    activator: '.ca-chapter__video--image',
    youtubeVideo: {
      wrapperId: 'chapterVideo'
    },
    onOpen: () => {
      let title: HTMLElement = document.querySelector('.ca-chapter__title')
      window.dataLayer.push({
        'event': 'trackEvent',
        'eventCategory': 'Aguila 100 años', // Categoría del evento (String). Requerido.
        'eventAction': 'Play Capítulos', // Acción o subcategoría del evento (String). Requerido.
        'eventLabel': title && title.innerText, // Etiqueta de descripción del evento (String). Requerido.
      });

    }
  })
}

//Datalayer Spotify
function dataLayer() {
  const btnSpotify = document.querySelector('.ca-chapter__socialMusic--spotify ')
  btnSpotify && btnSpotify.addEventListener('click', e => {
    window.dataLayer.push({
      'event': 'trackEvent',
      'eventCategory': 'Cerveza Águila', // Categoría del evento (String). Requerido.
      'eventAction': 'Clic de Sálida', // Acción o subcategoría del evento (String). Requerido.
      'eventLabel': 'Spotify', // Etiqueta de descripción del evento (String). Requerido.
    });

  })
}

// CARGA PARALLAX EN LAS FLORES
function loadParallax() {
  var scene = document.querySelector(
    ".ca-chapter-container__body-corners"
  );
  var scene2 = document.querySelector(
    ".ca-chapter-container__footer-flowers"
  );
  new Parallax(scene);
  new Parallax(scene2);
}

// CARGA LAS MARIPOSAS QUE SE AGREGARAN AL SITIO
function loadChapterButterfly() {
  animateButterfly({
    refButterfly: "ca-butterfly-c1",
    parentWrapper: ".ca-chapter-container__body-butterflys",
    start: {
      rotateZ: -28,
      scale: 0.7,
      bottom: "70%",
      right: "70%",
    },
    end: {
      duration: 10,
      bottom: "100%",
      right: "100%",
    }
  });

  animateButterfly({
    refButterfly: "ca-butterfly-c2",
    parentWrapper: ".ca-chapter-container__body-butterflys",
    start: {
      rotateZ: 38,
      scale: 0.4,
      bottom: "60%",
      left: "68%",
    },
    end: {
      duration: 10,
      bottom: "80%",
      left: "100%",
    }
  });

  animateButterfly({
    refButterfly: "ca-butterfly-c3",
    parentWrapper: ".ca-chapter-container__body-butterflys",
    start: {
      rotateZ: -48,
      scale: 0.6,
      bottom: "50%",
      right: "70%",
    },
    end: {
      duration: 8,
      bottom: "65%",
      right: "100%",
    }
  });

  animateButterfly({
    refButterfly: "ca-butterfly-c4",
    parentWrapper: ".ca-chapter-container__body-butterflys",
    start: {
      rotateZ: 28,
      scale: 0.6,
      bottom: "45%",
      left: "70%",
    },
    end: {
      duration: 10,
      bottom: "70%",
      left: "100%",
    }
  });
}

// AGREGA ANIMACION A LAS FLORES DE LA PARTE DE ARRIBA
function setTopFlowersAnimation(): void {
  const tl = gsap.timeline();

  ScrollTriggerAll(
    "center",
    ".ca-chapter-container__body-corner",
    (currentElement) => {
      tl.to(currentElement, {
        duration: 0.8,
        opacity: 1,
        stagger: 0.4,
        ease: "circ.in",
      });
    }
  );
}

// AGREGA ANIMACION AL TITULO DEBAJO DEL CANVAS
function setTitleAnimation() {
  let number = ".ca-float-header .ca-float-header__number-chapter";
  let title = ".ca-float-header .ca-float-header__title-chapter";

  gsap.to(`${number}, ${title}`, {
    duration: 2,
    opacity: 1,
    translateX: 0,
    ease: "expo.inOut",
  });
}

// AGREGA ANIMACION AL CONTENIDO PRINCIPAL (TEXTO, VIDEO, AUDIO)
function setTopContainAnimation() {
  let mainContent =
    ".ca-chapter__content p, .ca-chapter__content .ca-chapter__sound-container, .ca-chapter__content .ca-chapter__video, h2.ca-sound-cloud-message, .ca-chapter__socialMusic--soundcloud, .ca-chapter__socialMusic--spotify";

  ScrollTriggerAll(
    "top",
    `${mainContent}, .ca-chapter__number, .ca-chapter__header`,
    (currentElement) => {
      gsap.to(currentElement, {
        duration: 1,
        opacity: 1,
        translateX: 0,
        ease: "power2.inOut",
      });
    }
  );

  gsap.set(".ca-return-home-button, .ca-chapter-container__footer-body h3, .ca-group-button", { opacity: 0, blur: "5px" });
  ScrollTriggerAll(
    "top",
    ".ca-return-home-button, .ca-chapter-container__footer-body h3, .ca-group-button",
    (currentTarget) => {
      gsap.to(currentTarget, {
        duration: 2,
        opacity: 1,
        blur: "0px",
      });
    }
  );
}

// AGREGA ANIMACION AL BOTON DE COMPARTIR
function setHandlerShareButton() {
  let refShareButtons = document.querySelectorAll(
    ".ca-share .ca-share__main"
  );
  if (refShareButtons) {
    for (let i = 0; i < refShareButtons.length; i++) {
      refShareButtons[i].addEventListener("click", (e) => {
        let currentTarget = e.target as Element;
        gsap.to(currentTarget, {
          durantion: 1,
          transformOrigin: "top",
          rotateX: 180,
        });
        gsap.to(currentTarget, {
          durantion: 0.7,
          opacity: 0,
          delay: 0.3,
          backgroundColor: "#001E5A",
        });
      });
    }
  }
}

// MUESTRA EL STICKY DEL NEWSLETTER
function showSticky() {
  // selecciona el nodo target
  let isVisibleSticky: boolean = false;
  let target = document.querySelector('.UI-carrouselArrow.UI-prev');
  let newsletter = document.querySelector('#newsletterImage');
  let coomingSoon = document.querySelector('.UI-proximamente');
  let footer = document.querySelector('.site-footer');

  if (newsletter && coomingSoon) {
    // MUTATION
    let config = { attributes: true, childList: true, characterData: true };
    let mObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation: any) {
        if (mutation.target.classList.contains('active')) {
          newsletter.classList.add('ca-visible-sticky')
          coomingSoon.classList.add('cooming-visible')
          isVisibleSticky = true
        }
        else {
          coomingSoon.classList.remove('cooming-visible')
          newsletter.classList.remove('ca-visible-sticky')
          isVisibleSticky = false
        }
      });
    });
    mObserver.observe(target, config);

    // INTERSECTION
    let options = { rootMargin: "0px", threshold: 0.2 };
    let iObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (isVisibleSticky) {
          if (entry.isIntersecting) {
            newsletter.classList.remove('ca-visible-sticky')
          }
          else {
            newsletter.classList.add('ca-visible-sticky')
          }
        }
      });
    }, options);
    iObserver.observe(footer);
  }

}

// SCROLL DOWN
function scrollInfo() {
  if (window.location.search == '?scrollDown') {
    window.scroll({
      top: 600,
      left: 0,
    });
  }
}
window.scrollInfo = scrollInfo